import { render, staticRenderFns } from "./TwoFactorVerify.vue?vue&type=template&id=efef2a26&"
import script from "./TwoFactorVerify.vue?vue&type=script&lang=js&"
export * from "./TwoFactorVerify.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorVerify.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports